<template>
  <span>
    <div class="flex-itens">
      <p>{{ number ? number.toFixed(1) : 0 }}</p>
      <div v-if="max === 1000 && canReloadScore" class="pointer" @click="reloadAnalisy">
        <b-img
          :class="{ loading: loading }"
          :src="require('@assets/images/raio.svg')"
        ></b-img>
      </div>
    </div>
    <div>
      <b-progress v-if="allResult >= 0 && allResult <= 1"
        class="mt-2"
        :max="maxResult"
        height="4px"
      >
        <b-progress-bar
          v-if="max === 100"
          :value="result"
          class="success-custom"
        ></b-progress-bar>
        <b-progress-bar
          v-if="max === 100"
          :value="0"
          class="warning-custom"
        ></b-progress-bar>
        <b-progress-bar
          v-if="max === 100"
          :value="0"
          class="danger-custom"
        ></b-progress-bar>

        <b-progress-bar
          v-if="max === 1000"
          :value="result"
          class="danger-custom"
        ></b-progress-bar>
        <b-progress-bar
          v-if="max === 1000"
          :value="0"
          class="warning-custom"
        ></b-progress-bar>
        <b-progress-bar
          v-if="max === 1000"
          :value="0"
          class="success-custom"
        ></b-progress-bar>
      </b-progress>
      <b-progress v-if="allResult > 1 && allResult <= 2"
        class="mt-2"
        :max="maxResult"
        height="4px"
      >
        <b-progress-bar
          v-if="max === 100"
          :value="33.3"
          class="success-custom"
        ></b-progress-bar>
        <b-progress-bar
          v-if="max === 100"
          :value="result"
          class="warning-custom"
        ></b-progress-bar>
        <b-progress-bar
          v-if="max === 100"
          :value="0"
          class="danger-custom"
        ></b-progress-bar>

        <b-progress-bar
          v-if="max === 1000"
          :value="33.3"
          class="danger-custom"
        ></b-progress-bar>
        <b-progress-bar
          v-if="max === 1000"
          :value="result"
          class="warning-custom"
        ></b-progress-bar>
        <b-progress-bar
          v-if="max === 1000"
          :value="0"
          class="success-custom"
        ></b-progress-bar>
      </b-progress>
      <b-progress v-if="allResult > 2 && allResult <= 3"
        class="mt-2"
        :max="maxResult"
        height="4px"
      >
        <b-progress-bar
          v-if="max === 100"
          :value="33.3"
          class="success-custom"
        ></b-progress-bar>
        <b-progress-bar
          v-if="max === 100"
          :value="33.3"
          class="warning-custom"
        ></b-progress-bar>
        <b-progress-bar
          v-if="max === 100"
          :value="result"
          class="danger-custom"
        ></b-progress-bar>

        <b-progress-bar
          v-if="max === 1000"
          :value="33.3"
          class="danger-custom"
        ></b-progress-bar>
        <b-progress-bar
          v-if="max === 1000"
          :value="33.3"
          class="warning-custom"
        ></b-progress-bar>
        <b-progress-bar
          v-if="max === 1000"
          :value="result"
          class="success-custom"
        ></b-progress-bar>
      </b-progress>
      <b-progress v-if="allResult > 3"
        class="mt-2"
        :max="maxResult"
        height="4px"
      >
        <b-progress-bar
          v-if="max === 100"
          :value="33.3"
          class="success-custom"
        ></b-progress-bar>
        <b-progress-bar
          v-if="max === 100"
          :value="33.3"
          class="warning-custom"
        ></b-progress-bar>
        <b-progress-bar
          v-if="max === 100"
          :value="33.3"
          class="danger-custom"
        ></b-progress-bar>

        <b-progress-bar
          v-if="max === 1000"
          :value="33.3"
          class="danger-custom"
        ></b-progress-bar>
        <b-progress-bar
          v-if="max === 1000"
          :value="33.3"
          class="warning-custom"
        ></b-progress-bar>
        <b-progress-bar
          v-if="max === 1000"
          :value="33.3"
          class="success-custom"
        ></b-progress-bar>
      </b-progress>
    </div>
    <div v-if="null" class="date">
      <p>{{ data.data.created_at | datetime }}</p>
    </div>
    <div v-if="link" class="link link-hover">
      <router-link target="_blank" :to="link"
        ><p>Visualizar detalhes</p></router-link
      >
    </div>
    <div v-else class="link-sem-analise">
      <p>Venda Sem Analise</p>
    </div>
  </span>
</template>

<script>
import AnalysisService from '@services/resources/AnalysisService'
import {AccessLevel} from "@views/configurations/enums/accessLevel";
var service = AnalysisService.build()

export default {
  props: {
    value: {
      required: false,
      type: Number,
      default: 0
    },
    max: {
      required: false,
      type: Number,
      default: 0
    },
    link: {
      required: false,
      type: String,
      default: ""
    },
    data: {
      required: false,
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    canReloadScore() {
      return this.$canAction('risk_analysis_reload_score', AccessLevel.READER)
    },
  },
  data() {
    return {
      allResult: 0,
      loading: false,
      maxResult: 100,
      number: null,
      result: 0,
    }
  },
  mounted() {
    this.getPorcentage()
    this.number = this.value
  },
  methods: {
    reloadAnalisy() {
      this.loading = true
      service
        .read('/update-score/' + this.link.split('/')[3])
        .then((resp) => {
          this.number = resp.avg_user_scores
        })
        .catch(err => console.error(err))
        .finally(() => { this.loading = false })
    },
    getPorcentage() {
      if (this.max === 100) {
        this.maxResult = 100
        let porcentage = this.value
        let result = porcentage / 33.33
        this.allResult = result
        if (result > 0 && result <= 1) {
          this.result = (result).toFixed(2) * 33.33
        } else if (result > 1 && result <= 2) {
          this.result = (result - 1).toFixed(2) * 33.33
        } else if (result > 2 && result <= 3) {
          this.result = (result - 2).toFixed(2) * 33.33
        } else {
          this.result = 3
        }
        this.result = this.allResult >= 0 && this.allResult <= 1 ? ++this.result : this.result
        if(this.result < 0) this.result = this.result * (-1)
      }
      if (this.max === 1000) {
        this.maxResult = this.max / 10
        let porcentage = this.value / 10
        let result = porcentage / 33.33
        this.allResult = result
        if (result >= 0 && result <= 1) {
          this.result = (result).toFixed(2) * 33.33
        } else if (result > 1 && result <= 2) {
          this.result = (result - 1).toFixed(2) * 33.33
        } else if (result > 2 && result <= 3) {
          this.result = (result - 2).toFixed(2) * 33.33
        } else {
          this.result = 3
        }
        this.result = this.allResult >= 0 && this.allResult <= 1 ? ++this.result : this.result
        if(this.result < 0) this.result = this.result * (-1)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.flex-itens {
  height: 20px;
  p {
    font-weight: 600;
    font-size: 18px;
    letter-spacing: 0.2px;
    color: #000000;
  }
  svg {
    margin-top: 7px;
    cursor: pointer;
  }
  display: flex;
  gap: 20px;
}

.pointer {
  cursor: pointer;
}

.link-sem-analise {
  p {
    font-weight: 400;
    font-size: 13px;
    letter-spacing: 0.2px;
    color: #81858e;
    margin-top: 10px;
  }
}

.link {
  cursor: pointer;
  p {
    font-weight: 400;
    font-size: 13px;
    letter-spacing: 0.2px;
    color: #81858e;
    margin-top: 10px;
  }
}

.date {
  p {
    font-weight: 400;
    font-size: 11px;
    letter-spacing: 0.2px;
    color: #81858e;
    margin-top: 10px;
  }
}

p,
span {
  font-family: 'Montserrat';
  font-style: normal;
  margin: 0;
}

.loading {
  -webkit-animation: spin 4s linear infinite;
  -moz-animation: spin 4s linear infinite;
  animation: spin 4s linear infinite;
}
@-moz-keyframes spin {
  100% {
    -moz-transform: rotate(360deg);
  }
}
@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.link-hover:hover{
  p {
    color: #00897b;
  }
}
</style>